import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { getFileExtension, generateFileName } from '../utils/file';
import { STORAGE_PATHS } from '../constants';
import { API_ENDPOINTS } from '../constants';

class S3Service {
    constructor() {
        this.publicUrl = 'https://cloud.niceapp.tech';
        this.s3Client = new S3Client({
            region: 'ru-1',
            endpoint: import.meta.env.VITE_S3_ENDPOINT,
            credentials: {
                accessKeyId: import.meta.env.VITE_S3_ACCESS_KEY,
                secretAccessKey: import.meta.env.VITE_S3_SECRET_KEY
            },
            forcePathStyle: true
        });
    }

    async uploadFile(file, folder) {
        try {
            const fileName = generateFileName(file, folder);
            const fileBuffer = await this.fileToBuffer(file);

            const command = new PutObjectCommand({
                Bucket: import.meta.env.VITE_S3_BUCKET,
                Key: fileName,
                Body: fileBuffer,
                ContentType: file.type,
                ACL: 'public-read'
            });

            await this.s3Client.send(command);
            return `${this.publicUrl}/${fileName}`;
        } catch (error) {
            console.error('Upload error:', error);
            throw new Error('Ошибка при загрузке файла: ' + error.message);
        }
    }

    async fileToBuffer(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const arrayBuffer = reader.result;
                const buffer = new Uint8Array(arrayBuffer);
                resolve(buffer);
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(file);
        });
    }

    isS3Link(url) {
        return url?.includes('cloud.niceapp.tech') || 
               url?.includes('s3.timeweb.cloud');
    }

    async getDownloadLink(url) {
        if (url?.includes('s3.timeweb.cloud')) {
            const path = url.split(import.meta.env.VITE_S3_BUCKET + '/')[1];
            return `${this.publicUrl}/${path}`;
        }
        return url;
    }
}

export const s3Service = new S3Service(); 